import script from "./AudienceMixin.vue?vue&type=script&lang=ts"
export * from "./AudienceMixin.vue?vue&type=script&lang=ts"

export default script